import styled from "styled-components"
import {Body, H6} from "@irati/ui/src/Typography"
import Link from "@irati/ui/src/Link"

interface ContainerProps {
  pinned: boolean
  backgroundImage: string
  clicked: boolean
}

export const CustomLink = styled(Link)`
  padding: 0 !important;

  ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    min-height: 120px;
  `}
`

export const CardContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: ${({pinned}) => `0 ${pinned ? "0px" : "16px"} 0 16px`};
  background-color: ${({clicked, theme}) => (clicked ? theme.colors.greys.graphGrey : theme.colors.greys.white)};
  background-image: url(${({backgroundImage}) => backgroundImage});
  background-blend-mode: multiply;
  position: relative;
`

export const InfoContainer = styled.div`
  width: 260px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  flex-grow: 1;
  margin: ${({theme}) => theme.spacing.two};
`

export const Title = styled(H6)`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: ${({theme}) => theme.colors.greys.black};
`

export const Description = styled(Body)`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: ${({theme}) => theme.spacing.half}
    ${({theme}) => theme.mediaQueries.maxWidthMedia.tablet`
    margin: 0 !important;
  `};
`

export const Cta = styled.div`
  margin-top: ${({theme}) => theme.spacing.one};
`

export const TimeCreated = styled(H6)`
  padding-top: ${({theme}) => theme.spacing.two};
  color: ${({theme}) => theme.colors.greys.disabledText};
`

export const PinnedWrapper = styled.div`
  position: relative;
  right: 0;
  top: -1px;
`
